export const PlaceholderComponent = () => <div>Loading...</div>;